

import { createSlice } from "@reduxjs/toolkit";
import { IOrderItems } from "../interface/IOrderItem";

const initialState: IOrderItems[] | null = null;

const orderItemsSlice = createSlice({
    name: "orderItems",
    initialState,
    reducers: {
        setOrderItemsStore: (state, action) => {
            return action.payload;
        },
        setOrderItemsNull: (state, action) => {
            return null;
        }
    },
});

export const { setOrderItemsStore, setOrderItemsNull } = orderItemsSlice.actions

export default orderItemsSlice.reducer;
